import { useContext, useEffect, useState } from 'react';

import TranslationsContext from 'services/context/translationsContext';

const useTranslations = () => {
  const [translations, setTranslations] = useState(() => '');
  const translationsContext = useContext(TranslationsContext);
  useEffect(() => {
    if (translationsContext.translations !== null) {
      setTranslations(translationsContext.translations);
    }
  }, [translations, translationsContext.translations]);

  return (identifier) => translations?.[identifier] ?? '';
};

export default useTranslations;
